import { AUTH, PRESCREENING, ROUTE } from '@/constants';
import store from '@/store';

const navigationGuard = {
  async setupAuthorizationAndApp() {
    if (!store.getters['auth/isAuthenticated']) {
      await store.dispatch('core/authorizeAndInitApp');
    }
    return store.getters['auth/isAuthenticated']
      ? AUTH.USER_ROLE.AUTHORIZED
      : AUTH.USER_ROLE.NOT_AUTHORIZED;
  },
  async setupApp() {
    if (!store.getters['core/account']) {
      await store.dispatch('core/initApp');
    }
    return;
  },
  getOnBoardingStatus() {
    return store.getters['core/approvalKey'];
  },
  checkPermittedPath(routes) {
    const paths = routes.map((route) => route.path);
    const permittedPaths = store.getters['core/permittedRoutePaths'];
    return paths.some((path) => permittedPaths.includes(path));
  },
  setupDefaultRoute(status) {
    switch (status) {
      case PRESCREENING.APPROVAL_KEY.APPROVED:
      case PRESCREENING.APPROVAL_KEY.WALLET_FAILED:
        return ROUTE.NAME.ASSIGNMENT;
      case PRESCREENING.APPROVAL_KEY.COMPLETED:
      case PRESCREENING.APPROVAL_KEY.REJECTED:
      case PRESCREENING.APPROVAL_KEY.TODO:
        return ROUTE.NAME.MY_ACCOUNT;
      default:
        return ROUTE.NAME.NOT_FOUND;
    }
  },
};

export default navigationGuard;
